import { css } from 'styled-components'
import type { CSSProp } from 'styled-components'

const layout = {
  maxFlex: 6,
  baseFlex: 2,
  gridGap: 20,
  smallMobile: { minWidth: 0, maxWidth: 374 },
  regularMobile: { minWidth: 375, maxWidth: 767 },
  mobile: { minWidth: 0, maxWidth: 767 },
  tablet: {
    minWidth: 768,
    maxWidth: 993,
    contentArea: 664,
  },
  desktop: {
    minWidth: 994,
    contentArea: 954,
  },
}

const breakpoints = {
  smallMobile: `(max-width: ${layout.smallMobile.maxWidth}px)`,
  regularMobile: `(min-width: ${layout.regularMobile.minWidth}px) and (max-width: ${layout.regularMobile.maxWidth}px)`,
  mobile: `(max-width: ${layout.mobile.maxWidth}px)`,
  tablet: `(min-width: ${layout.tablet.minWidth}px) and (max-width: ${layout.tablet.maxWidth}px)`,
  desktop: `(min-width: ${layout.desktop.minWidth}px)`,
}

const smallMobileCSS = (styles: CSSProp) => css`
  @media ${breakpoints.smallMobile} {
    ${styles}
  }
`

const regularMobileCSS = (styles: CSSProp) => css`
  @media ${breakpoints.regularMobile} {
    ${styles}
  }
`
const mobileCSS = (styles: CSSProp) => css`
  @media ${breakpoints.mobile} {
    ${styles}
  }
`

const tabletCSS = (styles: CSSProp) => css`
  @media ${breakpoints.tablet} {
    ${styles}
  }
`

const desktopCSS = (styles: CSSProp) => css`
  @media ${breakpoints.desktop} {
    ${styles}
  }
`

/* 1593px is after talking to Ringier Advertising */
const desktopLeftAlignedCSS = (styles: CSSProp) => css`
  @media screen and (max-width: 1593px) {
    ${styles}
  }
`

/* 1594px is after talking to Ringier Advertising */
const desktopCenteredContentCSS = (styles: CSSProp) => css`
  @media screen and (min-width: 1594px) {
    ${styles}
  }
`

const landscapeOrientationCSS = (styles: CSSProp) => css`
  @media (orientation: landscape) {
    ${styles}
  }
`

const getCurrentViewportType = (): 'desktop' | 'tablet' | 'mobile' | '' =>
  typeof window === 'undefined'
    ? ''
    : window.matchMedia(breakpoints.desktop).matches
    ? 'desktop'
    : window.matchMedia(breakpoints.tablet).matches
    ? 'tablet'
    : 'mobile'

const isIos = () => {
  const userAgent =
    typeof navigator === 'undefined' ? 'SSR' : navigator.userAgent
  return (
    !!userAgent.match(/iPhone|iPad|iPod/i) ||
    (!!userAgent.match(/Intel Mac OS X/i) && navigator.maxTouchPoints > 0)
  )
}

const isMobileUserAgent = () => {
  const userAgent =
    typeof navigator === 'undefined' ? 'SSR' : navigator.userAgent
  const isAndroid = !!userAgent.match(/Android/i)
  const isOpera = !!userAgent.match(/Opera Mini/i)
  const isWindows = !!userAgent.match(/IEMobile/i)
  return isAndroid || isIos() || isOpera || isWindows
}

export {
  layout,
  breakpoints,
  smallMobileCSS,
  regularMobileCSS,
  mobileCSS,
  tabletCSS,
  desktopCSS,
  desktopLeftAlignedCSS,
  desktopCenteredContentCSS,
  landscapeOrientationCSS,
  getCurrentViewportType,
  isMobileUserAgent,
  isIos,
}
